/**
 * External dependencies
 */
import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Internal dependencies
 */
import {
  ERROR_BOUND_CONTAINER,
  ERROR_BOUND_INNER_CONTAINER,
  ERROR_BOUND_TITLE_STYLE,
  ERROR_BOUND_NAME_STYLE,
  ERROR_BOUND_CONTENT_STYLE,
  ERROR_BOUND_CONTENT1_STYLE
} from './style';
import { ErrorPageProps } from './types';

function ErrorPage(props: ErrorPageProps): React.ReactElement {
  /* Global & Local State */
  const { errorName, errorStack } = props;

  /* Main */
  return (
    <Box sx={{ ...ERROR_BOUND_CONTAINER }}>
      <Box sx={{ ...ERROR_BOUND_INNER_CONTAINER }}>
        <Typography variant="h3" sx={{ ...ERROR_BOUND_TITLE_STYLE }}>
          Oops ! Something Wrong
        </Typography>
        <Typography variant="h4" sx={{ ...ERROR_BOUND_NAME_STYLE }}>
          {errorName && `Error : ${errorName}`}
        </Typography>
        <Typography variant="h4" sx={{ ...ERROR_BOUND_CONTENT_STYLE }}>
          {errorStack && 'Error Content :'}
        </Typography>
        <Typography variant="h5" sx={{ ...ERROR_BOUND_CONTENT1_STYLE }}>
          {errorStack && errorStack}
        </Typography>
      </Box>
    </Box>
  );
}

export default memo(ErrorPage);
